/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportAenderung
 */
export interface ImportAenderung {
    /**
     * 
     * @type {string}
     * @memberof ImportAenderung
     */
    vertragsNummer: string;
    /**
     * 
     * @type {string}
     * @memberof ImportAenderung
     */
    vertragsName: string;
    /**
     * 
     * @type {string}
     * @memberof ImportAenderung
     */
    maschinenGruppe: string;
    /**
     * 
     * @type {number}
     * @memberof ImportAenderung
     */
    berichtsNummer: number;
    /**
     * 
     * @type {number}
     * @memberof ImportAenderung
     */
    summeNetto: number;
    /**
     * 
     * @type {number}
     * @memberof ImportAenderung
     */
    vorhergehendeSummeNetto?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportAenderung
     */
    vorhergehendeImportId?: number;
    /**
     * 
     * @type {string}
     * @memberof ImportAenderung
     */
    vorhergehenderImportAm?: string;
}

/**
 * Check if a given object implements the ImportAenderung interface.
 */
export function instanceOfImportAenderung(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "vertragsNummer" in value;
    isInstance = isInstance && "vertragsName" in value;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "berichtsNummer" in value;
    isInstance = isInstance && "summeNetto" in value;

    return isInstance;
}

export function ImportAenderungFromJSON(json: any): ImportAenderung {
    return ImportAenderungFromJSONTyped(json, false);
}

export function ImportAenderungFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportAenderung {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vertragsNummer': json['vertragsNummer'],
        'vertragsName': json['vertragsName'],
        'maschinenGruppe': json['maschinenGruppe'],
        'berichtsNummer': json['berichtsNummer'],
        'summeNetto': json['summeNetto'],
        'vorhergehendeSummeNetto': !exists(json, 'vorhergehendeSummeNetto') ? undefined : json['vorhergehendeSummeNetto'],
        'vorhergehendeImportId': !exists(json, 'vorhergehendeImportId') ? undefined : json['vorhergehendeImportId'],
        'vorhergehenderImportAm': !exists(json, 'vorhergehenderImportAm') ? undefined : json['vorhergehenderImportAm'],
    };
}

export function ImportAenderungToJSON(value?: ImportAenderung | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vertragsNummer': value.vertragsNummer,
        'vertragsName': value.vertragsName,
        'maschinenGruppe': value.maschinenGruppe,
        'berichtsNummer': value.berichtsNummer,
        'summeNetto': value.summeNetto,
        'vorhergehendeSummeNetto': value.vorhergehendeSummeNetto,
        'vorhergehendeImportId': value.vorhergehendeImportId,
        'vorhergehenderImportAm': value.vorhergehenderImportAm,
    };
}

